<template>
    <label :class="componentClassName">
        <span class="ic-icons">
            <span v-show="isTheBloodyThisSelected == false" :disabled="disabled" :class="{'disabled' : disabled}"><i class="far fa-square"></i></span>
            <span v-show="isTheBloodyThisSelected == true" :disabled="disabled" :class="{'disabled' : disabled}"><i class="far fa-check-square"></i></span>
            <input type="checkbox" v-model="vm.isSelected" :style="{opacity: '0', width: '0', height: '0', position: 'absolute'}" :disabled="disabled" :class="{'disabled' : disabled}" />
        </span>
        <span class="ic-label" :disabled="disabled" :class="{'disabled' : disabled}">
            {{label === '_' ? '\u00A0' : label}}
        </span>
    </label>
</template>


<script>
    export default {
        name: "InputCheckbox",
        props: ['value', 'label', 'disabled', "sfx"],
        data() {
            return {
                vm: {
                    isSelected: false
                }
            };
        },
        computed: {
            componentClassName() {
                if (this.sfx === false || this.disabled) return "clickable input-checkbox";

                return "clickable input-checkbox sfx";
            },
            isTheBloodyThisSelected() {
                if (this.vm.isSelected) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        created() {
            this.init();

            this.$watch(() => this.$props, function (newValue) {
                this.init();
            }, { deep: true });

            this.$watch(() => this.vm, function (newValue) {
                this.$emit('input', this.vm.isSelected);
                this.$emit('change');
            }, { deep: true });

        },
        methods: {
            init() {
                if (this.value) {
                    this.vm.isSelected = true;
                } else {
                    this.vm.isSelected = false;
                }
            },
            toggle() {
                this.vm.isSelected = !this.vm.isSelected;
                this.$emit('change', this.vm.isSelected);

            }
        },
        components: {

        }
    };
</script>

<style>
    .input-checkbox.sfx {
        transition: all 0.2s ease-out;
    }

        .input-checkbox.sfx:hover {
            color: var(--main-color);
            transition: all 0.2s ease-out;
        }
</style>
